import { Col, Row } from 'antd';
import React from 'react'
import ProgressCard from '../../biblio/progress/ProgressCard';
interface Props {
    question: any
}
const ResultChoices = ({ question }: Props) => {
  return (
    <div className="takaful--question-content-list">
      {question.choices?.map((choice: any) => (
        <Row>
          <Col xxl={10} xl={10} lg={10} md={10} sm={24} xs={24}>
            <span className="takaful--content-services-request-span takaful--color-span">
              {choice?.choice}
            </span>
          </Col>
          <Col xxl={14} xl={14} lg={14} md={14} sm={24} xs={24}>
            <ProgressCard
              className="takaful--survey-progress"
              percent={Math.floor(choice?.percent)}
              percentPosition={{
                align: "end",
                type: "inner",
              }}
              surveyColor={true}
              size={["100%", 15]}
              alternativeColor={true}
            />
          </Col>
        </Row>
      ))}
    </div>
  );
}

export default ResultChoices